import React from 'react'
import popup from '~/views/Popup/popup'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class UserInfo extends React.Component {
  isVLAuthenticated() {
    return this.state.user.provider === 'viewlift'
  }

  render() {
    return (
      <section>
        <div className="title site-color">Account Info</div>
        <div className="detail">
          <div className="title site-color">Email</div>
          <div className="main">
            <div className="key">{ (this.state.user && this.state.user.email) || '...' }</div>
          </div>
          { this.isVLAuthenticated() &&
            <div className="buttons">
              <div className="button" onClick={_ => popup.updateProfile() }>Edit profile</div>
            </div>
          }
        </div>

        <div className="detail">
          <div className="title site-color">Name</div>
          <div className="main">
            <div className="key">{ (this.state.user && this.state.user.name) || '' }</div>
          </div>
          { this.isVLAuthenticated() &&
            <div className="buttons">
              <div className="button" onClick={_ => popup.changePassword() }>
                Change password
              </div>
            </div>
          }
        </div>
      </section>
    )
  }
}

connect(UserInfo, (state) => ({ user: state.user }), userStore)

export default UserInfo;
